var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconOpenInFull48Line = function SvgIconOpenInFull48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.852 11.152a2.869 2.869 0 0 0-2.13-.85l-8.68.21.08 3.4 5.7-.14-18.05 18 .14-5.7-3.4-.08-.21 8.69a2.899 2.899 0 0 0 2.9 3h.07l8.68-.22-.08-3.39-5.7.13 18-18-.14 5.7 3.4.08.21-8.68a2.901 2.901 0 0 0-.79-2.15Z",
    fill: "current"
  })));
};
export default SvgIconOpenInFull48Line;